import type { EnrichedClientDto } from '../api/generated/client';

/**
 * Cross-border client: RM location not equal to client main domicile.
 */
export function isCrossBorderClient(client: EnrichedClientDto | null | undefined): boolean {
    if (!client?.mainDomicile?.countryCode || !client?.rmLocationCountryCode) {
        return false;
    }

    return client.mainDomicile.countryCode.toUpperCase() !== client.rmLocationCountryCode.toUpperCase();
}
